import axios, { AxiosResponse } from "axios";
import { LogHelper } from "../helpers/LogHelper";
import { endpoints } from "../../site/configuration/endpoints";
import { User } from "oidc-client-ts";
import authenticationSettings from "../../site/configuration/AuthenticationSettings";
import { getOidcAccessToken } from "../helpers/OidcAccessTokenHelper";

export const GetLastCallTime = (): number => {
  var storedDate = sessionStorage.getItem("api:lastCallTimestamp");
  if (storedDate) {
    return parseFloat(storedDate);
  }
  return 0;
};
const SetLastCallTime = () => {
  sessionStorage.setItem("api:lastCallTimestamp", Date.now().toString());
};

function getUser() {
  const localStorageUserKey = `oidc.user:${authenticationSettings.oidcConfig.authority}:${authenticationSettings.oidcConfig.client_id}`;
  console.log(localStorageUserKey);
  const oidcStorage = sessionStorage.getItem(localStorageUserKey);
  if (!oidcStorage) {
    return null;
  }

  return User.fromStorageString(oidcStorage);
}

export const ParseAxiosHeaders = (response: AxiosResponse<any>) => {
  if (response && response.headers) {
    /*const environmentName: AppEnvironment | undefined =
      process.env.REACT_APP_API_ENVIRONMENT_HEADER &&
      response.headers[process.env.REACT_APP_API_ENVIRONMENT_HEADER];
    const buildVersion: string | undefined =
      process.env.REACT_APP_API_BUILDVERSION_HEADER &&
      response.headers[process.env.REACT_APP_API_BUILDVERSION_HEADER];*/
    // var vEnvironmentName: AppEnvironment | undefined = process.env
    //   .REACT_APP_BUILD_VERSION as AppEnvironment;
    // var vBuildVersion: string | undefined = process.env
    //   .REACT_APP_GUI_VERSION as string;
    // if (vEnvironmentName || vBuildVersion)
    //   store.dispatch(
    //     apiActions.setApiContextInfo({
    //       environmentName: vEnvironmentName,
    //       buildVersion: vBuildVersion,
    //     })
    //   );
  }
};

export const getCookieValue = (cookieName: string): string => {
  const allCookies = decodeURIComponent(document.cookie).split("; ");
  for (let i = 0; i < allCookies.length; i++) {
    const cookie = allCookies[i];
    if (cookie.startsWith(cookieName + "=")) {
      return cookie.substring(cookieName.length + 1);
    }
  }

  return "";
};

export const getAntiForgeryToken = async (): Promise<string> => {
  if (process.env.REACT_APP_API_CSRF_COOKIENAME) {
    /// Get CSRF Token from cookies
    var requestToken = getCookieValue(
      process.env.REACT_APP_API_CSRF_COOKIENAME
    );
    if (requestToken && requestToken !== "") return requestToken;

    /// no CSRF Token: Require it
    await fetch(endpoints.system.antiforgery, {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });
    return getCookieValue(process.env.REACT_APP_API_CSRF_COOKIENAME);
  } else return "";
};

export function ApiGateway() {
  //    let token = ServiceProvider.Auth.getToken();

  let headers = {
    accept: "application/json",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    "Access-Control-Expose-Headers": true,
    "X-Requested-With": "XMLHttpRequest",
    Authorization: "",
  };

  const oidcAccessToken: string | null = getOidcAccessToken();
  if (oidcAccessToken) {
    headers = {
      ...headers,
      Authorization: "Bearer " + oidcAccessToken,
    };
  }

  const axiosGateway = axios.create({
    baseURL: process.env.REACT_APP_AMP_API_URL,
    timeout: 120000,
    withCredentials: false,
  });
  //console.log(process.env.REACT_APP_API_URL)
  axiosGateway.defaults.headers.common = headers;
  axiosGateway.defaults.headers.patch = headers;
  axiosGateway.defaults.headers.post = headers;
  axiosGateway.defaults.headers.put = headers;
  axiosGateway.defaults.headers.get = headers;

  /*axiosGateway.interceptors.request.use(
    (request: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
      return new Promise<AxiosRequestConfig>((resolve, reject) => {
        getAntiForgeryToken()
          .then((token) => {
            const crsfHeaderName: string | undefined =
              process.env.REACT_APP_API_CSRF_HEADER;
            if (crsfHeaderName && token && token !== "") {
              resolve({
                ...request,
                headers: { ...request.headers, [crsfHeaderName]: token },
              });
            } else {
              resolve(request);
            }
          })
          .catch((error) => {
            LogHelper.error(error);
            resolve(request);
          });
      });
    }
  );*/

  axiosGateway.interceptors.request.use((config: any) => {
    //Add rMode to all calls as header parameter
    const urlParams = new URLSearchParams(window.location.search);
    const rmode = urlParams.get("rmode");
    if (rmode) config.headers = { ...config.headers, __rmode: rmode };

    return config;
  });

  axiosGateway.interceptors.response.use(
    (response: any) => {
      SetLastCallTime();
      return response;
    },
    (error: any) => {
      if (error.response && error.response != null) {
        if (error.response.status === 401) {
          window.location.reload();
        }
      }

      // LogHelper.error("Error", error);
      // if (error.response && error.response != null) {
      //   if (error.response.status === 401) {
      //     LogHelper.warn("Unauthorized - Refreshing credentials");
      //     //store.dispatch(authActions.TokenExpired(true));
      //   }
      // }

      /*
      else {
        // Risposta caduta nel vuoto.. mi aspetto che sia dovuto al redirect di ADFS
        // IMPOSTO IL FLAG DI RICHIESTA DI RICONNESSIONE
        store.dispatch({
          type: types.AUTH_TOKEN_EXPIRED,
          expired: true
        });
      }
*/

      return Promise.reject(error.response);
    }
  );

  return axiosGateway;
}

export default ApiGateway;
